import $ from 'jquery';
import { AJAX_URL } from '../config';
import { scrollToElement } from '../lib/utilities';

const urlParams = new URLSearchParams(window.location.search);

$(window).on('load', () => {
  if (urlParams.has('load')) {
    scrollToElement('.load-more-tax');
  }
});

$(() => {
  let $button = $('.load-more-tax');
  const $hidebutton = $('.hide-show-more-loader');

  if ($hidebutton.length != 0) {
    $button.hide();
  }

  $button.on('click', function () {
    $button = $(this);

    const sectionID = $button.parents('.section[id]').attr('id');
    const {
      taxonomyId,
      tvTaxonomy,
      postType,
      initialOffset,
      numberposts,
      cardType,
      modifier,
      postsDisplay
    } = $button.data();

    let offset;
    let currentOffset = $button.data('current-offset');

    if (currentOffset != undefined) {
      offset = currentOffset;
      offset++;
    } else {
      offset = initialOffset ? initialOffset / numberposts : 1;
    }

    $button.data('current-offset', offset);

    const data = {
      termId: taxonomyId,
      tvTaxonomy: tvTaxonomy,
      numberPosts: numberposts,
      postType: postType,
      offset: offset,
      cardType: cardType,
      modifier: modifier,
      postsDisplay: postsDisplay
    };

    // url parameter logic
    let loadTotal = 0;

    if (urlParams.has('load')) {
      loadTotal = parseInt(urlParams.get('load')) + data.numberPosts;
    } else {
      loadTotal = initialOffset + data.numberPosts;
    }

    urlParams.set('load', loadTotal);
    window.history.replaceState(null, null, `?${urlParams}`);

    // during load
    $button.parent().next('.loading').addClass('is-loading');
    $button.parents('.dotted-divider').addClass('is-loading');
    $button.hide();

    setTimeout(() => fetchPostsByTaxonomy(), 500);

    function fetchPostsByTaxonomy() {
      $.ajax({
        url: `${AJAX_URL}post_wlQueryTaxonomy`,
        data: data,
        type: 'POST',
        dataType: 'json',
        encode: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then(({ success, data }) => {
          $button.parent().next('.loading').removeClass('is-loading');

          if (success) {
            onFetchSuccess($button, data, offset, sectionID);
          } else {
            $button.text('Try Again').show();
          }
        })
        .catch((err) => console.log(err.message));
    }
    function onFetchSuccess($button, data, offset, sectionID) {
      if (Math.floor(offset) !== offset) {
        // number is not whole, adjust for css class DOM insertion
        offset = offset.toString();
        offset = offset.replace('.', '-');
      }

      $button
        .parents('.tax-container')
        .before(
          `<div class="ajax-${offset}-${sectionID}" style="opacity:0">${data}</div>`
        );

      $(`.ajax-${offset}-${sectionID}`).fadeTo(300, 1);

      const endOfPosts = determineIfEndOfPosts(offset, sectionID);

      if (!endOfPosts) {
        $('html').animate(
          {
            scrollTop: $(`.ajax-${offset}-${sectionID}`).offset().top - 200
          },
          1000
        );
        $button.parents('.dotted-divider').removeClass('is-loading');
        $button.show();
      } else {
        offset < 1 ? $button.text('No More Posts').show() : $button.hide();
      }
    }

    function determineIfEndOfPosts(offset, sectionID) {
      let endOfPosts =
        $(`.ajax-${offset}-${sectionID} [class^="grid__"]`).length < 4;

      if ($(`.ajax-${offset}-${sectionID} .grid__widescreen-lg`).length > 0) {
        endOfPosts =
          $(`.ajax-${offset}-${sectionID} .grid__widescreen-lg`).length < 3;
      }

      if ($(`.ajax-${offset}-${sectionID} .grid__section`).length > 0) {
        endOfPosts =
          $(`.ajax-${offset}-${sectionID} .grid__section`).length < 3;
      }

      return endOfPosts;
    }
  });
});
